import classes from '../../overlays/messages.module.scss'
import moment from 'moment'
import Button from '../../button'
import React, { useContext, useEffect, useState } from 'react'
import { SettingsContext } from '../../../lib/context/SettingsContext'
import { CartContext } from '../../../lib/context/cart-context'
import { useCookies } from 'react-cookie'
import ApiContext from '../../../utils/api-context'
import { useMutation } from '@apollo/client'
import { ADD_RETREAT_ENQUIRY } from '../../../lib/queries'
import { UserContext } from '../../../lib/context/UserContext'
import {
  calculateMarkup,
  formatAmountForDisplay,
} from '../../../utils/stripe-helpers'
import { CurrencyContext } from '../../../lib/context/CurrencyContext'
import packageRooms from '../../packages/package-rooms'
import { SearchContext } from '../../../lib/context/search-context'

const PreOrder = ({
  packageRoom,
  contact,
  onSend,
  checkIn,
  guests,
  parent,
}) => {
  const { user, setCurrentUser } = useContext(UserContext)
  const { currency } = useContext(CurrencyContext)
  const { settings } = useContext(SettingsContext)
  const [messageSent, setMessageSent] = useState(false)
  const [subTotal, setSubTotal] = useState(0)
  const [numRooms, setNumRooms] = useState(0)
  const [numGuests, setNumGuests] = useState(0)
  const [emailData, setEmailData] = useState({
    email: user && user.hasOwnProperty('email') ? user.email : '',
    name:
      user && user.hasOwnProperty('firstname') && user.firstname
        ? user.firstname + ' ' + user.lastname
        : '',
    subject: `Booking ${parent.name}`,
    message: '',
    phone: '',
  })
  const { addProduct, cartItems } = useContext(CartContext)
  const [cookies] = useCookies(['searchparams', 'cart', 'jwt'])
  const { apiUrl, cdnUrl } = useContext(ApiContext)
  const { searchParams } = useContext(SearchContext)
  const [createMessage] = useMutation(ADD_RETREAT_ENQUIRY)
  const handleDataChange = (evt) => {
    setEmailData({
      ...emailData,
      [`${evt.target.name}`]: evt.target.value,
    })
  }
  const moment = require('moment')
  const submitMessage = async () => {
    onSend().then((basket) => {
      createMessage({
        variables: {
          ...emailData,
          subject: `Wellness Traveller - ${
            emailData.subject
          } [REF: ${moment().format('YYYYMMDDHHmm')}]`,
          recipient: contact.email,
          retreat: parent.id,
          checkIn: moment(checkIn).format('YYYY-MM-DD'),
          customer: user.hasOwnProperty('id') ? user.id : null,
          dateSent: new Date(),
          sent: true,
          type: 'Retreat',
          guests: numGuests,
          cart: basket.itemIds.map((item) => item.id),
          // individual:
        },
      })
        .then((resp) => {
          setMessageSent(true)
        })
        .catch((resp) => {
          // console.log(resp)
        })
    })
  }
  useEffect(() => {
    let numberOfRooms = 0
    let sub = 0
    let numberOfGuests = 0
    // for (const g of searchParams.guests) {
    //   numberOfGuests += g.paxes.length
    // }
    for (const pR of packageRoom) {
      console.log(pR)
      if (!pR.optionLabel || pR.optionLabel === '' || pR.optionLabel === 'Room') {
        numberOfRooms += pR.quantity
        numberOfGuests += pR.occupancy
      } else {
        numberOfRooms += 1
        numberOfGuests += pR.quantity
      }
      
      if (pR.individual) {
        if (pR.price > 0) {
          sub += pR.price * pR.quantity
        }
      } else {
        if (pR.price > 0) {
          sub += pR.price
        }
      }
    }
    setSubTotal(sub)
    setNumRooms(numberOfRooms)
    setNumGuests(numberOfRooms)
  }, [packageRoom])
  return (
    <div className={classes.newMessage}>
      {!messageSent && (
        <>
          {parent.enquiryIntro && parent.enquiryIntro !== '' && (
            <div dangerouslySetInnerHTML={{ __html: parent.enquiryIntro }} />
          )}
          {(!parent.enquiryIntro || parent.enquiryIntro === '') &&
            settings.enquiryIntro && (
              <div
                dangerouslySetInnerHTML={{
                  __html: settings.enquiryIntro.packageEnquiry,
                }}
              />
            )}
          <>
            <ul className={classes.eventDetails}>
              
              <li>
                <strong>Total Number of Guests:</strong> {numGuests}
              </li>
              <li>
                <strong>Total Cost of Stay:</strong>{' '}
                {formatAmountForDisplay(
                  calculateMarkup(subTotal, settings.baseMarkup, parent.markup),
                  currency,
                  settings.exchangeRate
                )}
              </li>
            </ul>
            {packageRoom.map((pR, i) => {
              let price = 0
              let numberOfGuests = 0
              for (const g of searchParams.guests) {
                numberOfGuests += g.paxes.length
              }
              if (pR.individual) {
                if (pR.price > 0) {
                  price = pR.price * pR.quantity
                }
              } else {
                if (pR.price > 0) {
                  price = pR.price
                }
              }
              return (
                <ul key={i} className={classes.eventDetails}>
                  <li>
                    <strong>{pR.name}</strong>
                  </li>
                  <li>
                    <strong>Date Selected: </strong>{' '}
                    {moment(pR.checkin).format('DD/MM/YYYY')} -{' '}
                    {moment(pR.checkin)
                      .add(parent.nights, 'days')
                      .format('DD/MM/YYYY')}{' '}
                    ({parent.nights} x nights)
                  </li>
                  {pR.optionLabel && pR.optionLabel === 'Person' && (
                    <li>
                    <strong>Nr Guests: </strong> {pR.quantity}
                  </li>
                  )}
                  <li>
                    <strong>Price: </strong>{' '}
                    {formatAmountForDisplay(
                      price,
                      currency,
                      settings.exchangeRate
                    )}
                  </li>
                </ul>
              )
            })}
          </>
          <div className={classes.messageRow}>
            <input
              type="text"
              value={emailData.name}
              placeholder="Full name"
              onChange={handleDataChange}
              name="name"
              className={classes.half}
            />
            <input
              type="text"
              value={emailData.email}
              placeholder="Email Address"
              onChange={handleDataChange}
              name="email"
              className={classes.half}
            />
          </div>
          <div className={classes.messageRow}>
            <input
              type="text"
              value={emailData.phone}
              placeholder="Phone Number"
              onChange={handleDataChange}
              name="phone"
            />
          </div>
          <div className={classes.messageRow}>
            <input
              type="text"
              value={emailData.subject}
              placeholder="Subject"
              onChange={handleDataChange}
              name="subject"
            />
          </div>
          <div className={classes.messageRow}>
            <textarea
              value={emailData.message}
              placeholder="Your Message"
              onChange={handleDataChange}
              name="message"
              rows={6}
            />
          </div>
          <div className={classes.messageActions}>
            <Button width="100%" onClick={submitMessage} className={'cta-event-trigger'}>
              Send Message
            </Button>
          </div>
        </>
      )}
      {messageSent && emailData.email !== null && (
        <p>
          We&apos;ll be right back! A response will be in your Wellness
          Traveller account messages within 24 hours.
        </p>
      )}
    </div>
  )
}
export default PreOrder
